// extracted by mini-css-extract-plugin
export default {"submenu":"mainMenu_submenu__wySdI"};